export default {
    locale: "en",
    english: {
      What: "Location Empowered Insights",
      Subtext: "Location intelligence is the ability to analyze and find spatial patterns in data, to provide powerful insights into understanding our world and communicating our needs.",
      citation80pp:"80% of data has a location component",
      services:"Open Solutions",
      learnmore: "LEARN MORE >>>>",
      openvalues:"Building community driven Open Platforms, Geospatial datasets and their Use cases",
      ecosystem: "Ecosystem",
      ecosystemdescription:"Our mission is to develop community driven  platforms to democratize access to open geospatial datasets and build useful use cases for Business",
      openLIplatforms: 'Location Intelligence Open Platforms',
      freeGeoDatasets: 'Freely Available Geospatially Enabled Datasets',
      businessUseCases: 'Business Oriented Location Enabled Uses Cases',
      partners: 'Partners',
      enlightmeAbout: 'We are a startup working toward the large adoption of location intelligence technologies by small businesses.',
      enlightmeValues: 'Our values : Openness, Use case driven, Community empowerement',
      contactus: 'Contact us',
      platforms : 'Platforms',
      geodatasets : 'DataSets',
      usecases : 'Use Cases',
      businessmodel : 'Business Model',
      bmdescription1 : "Being engaged for openess, our innovative business model focus on creating real value for customers, by working toghter with them to digitally transfrom their organisation's business processes. Our value proposition focus on Customer Journey Optimisation and Lean Management deployment.",
      bmdescription2 : "In summary, our solutions are open and free of charge and we focus on integrating them in our customers premise to solve their day to day problems.",
    
    },
    arabic: {
      What: "تبصُر مستنِد على المواقع",
      Subtext: "الذكاء الجغرافي هو القدرة على التحليل والبحث عن العلاقات الفضائية المتواجدة بين البيانات، من أجل نظرة مستقبلية ثاقبة تساعدنا على فهم عالمنا و توضيح مبتغانا",
      citation80pp:"لأن ثمانين بالمائة (80%) من البيانات لها بعد جغرافي",
      services:"حلول مفتوحة",
      learnmore: "<<<< معرفة المزيد",      
      openvalues:"لننشئ معاً منصاتنا الرقمية المفتوحة و قواعد بياناتنا و سيناريوهات إستعمالها",
      ecosystem: "منظومة متكاملة",
      ecosystemdescription:" هدفنا التطوير الجماعي لمنصات رقمية لتعميم إستعمال البيانات الجغرافية المفتوحة و تحضير سيناريوهات للإستفادة منها في إدارة اﻷعمال",
      openLIplatforms: 'منصات مفتوحة للذكاء الجغرافي',
      freeGeoDatasets: 'قواعد بيانات مفتوحة و ذات بعد جغرافي',
      businessUseCases: 'تطبيقات مستندة على المواقع موجهة ﻹدارة اﻷعمال',
      partners: 'شركائنا',
      enlightmeAbout: 'نحن مؤسسة ناشئة تعمل على تدليل المصاعب امام المؤسسات الصغيرة و المتوسطة ﻹدماج الذكاء الجغرافي في مساراتها المهنية',
      enlightmeValues: 'قيمنا : اﻹنفتاح، العمل على تطبيقات مفيدة، التكافل إجتماعي',
      contactus: 'إتصل بنا',
      platforms : 'المنصات الرقمية',
      geodatasets : 'قواعد البينات',
      usecases : 'أمثلة إستعمال',
      businessmodel : 'النموذج اﻹقتصادي',
      bmdescription4 : "In summary, our solutions are open and free of charge and we focus on integrating them in our customers premise to solve their day to day problems.",
      bmdescription1 : "بصفتنا مصممين على اﻹنفتاح، فنموذجنا اﻹقتصادي المبتكر يركز على خلق قيمة مضافة حقيقية لزبائننا، بالعمل معهم يدا بيد لتجسيد التحول الرقمي لمساراتهم المهنية. خدماتنا تهدف أساسا للتحكم في مسارات العملاء و كذا إرساء أساليب اﻹدارة اﻹنسيابية ",
      bmdescription2 : "كخلاصة، حلولنا مفتوحة و مجانية، و أما نحن فنركز على إدماجها عند زبائننا من أجل حلحلت مشاكلهم اليومية",

    }
  };
  